import {
  PromoType,
  type PromosV1,
} from '@hungryroot/rest/api/get_pricing_config/get';

export const getLabelAndValue = ({
  type,
  effect,
  discount,
}: Pick<PromosV1, 'type' | 'effect'> & { discount?: number | null }) => {
  switch (type) {
    case PromoType.FLAT_DISCOUNT:
      return {
        label: effect,
        value: discount,
      };
    case PromoType.FREE_SHIPPING:
      return {
        label: `Shipping`,
        value: null,
      };
    case PromoType.FREE_ITEM:
    case PromoType.FREE_ITEM_FOR_LIFE:
      return {
        label: effect.split('free ')[1],
        value: null,
      };
    case PromoType.REFERRAL_DISCOUNT:
      return {
        label: effect,
        value: discount,
      };
    case PromoType.PERCENT_DISCOUNT:
      return {
        label: effect,
        value: discount,
      };
  }
  return { label: effect, value: null };
};
